<fieldset class="mb-3" [formGroup]="replacementDateGroup" *ngIf="visible$ | async">
    <div class="row justify-content-between">
        <div class="col-auto col-sm-7 d-flex flex-column flex-sm-row gap-2">
            <span class="options">
                <label>
                    <input
                        type="radio"
                        class="form-check-input"
                        [value]="REPLACEMENT_DATE_SELECTION.STARTUP_DATE"
                        [checked]="(replacementDate$ | async).selected === REPLACEMENT_DATE_SELECTION.STARTUP_DATE"
                        formControlName="radio"
                    />
                    {{ (replacementDate$ | async).startupDateLabel }}
                </label>
            </span>
            <span class="options">
                <label>
                    <input
                        type="radio"
                        class="form-check-input"
                        [value]="REPLACEMENT_DATE_SELECTION.OTHER_DATE"
                        [checked]="(replacementDate$ | async).selected === REPLACEMENT_DATE_SELECTION.OTHER_DATE"
                        formControlName="radio"
                    />
                    {{ (replacementDate$ | async).replacementDateLabel }}
                </label>
            </span>
        </div>
        <div class="col-auto col-sm-5 align-self-end pe-0">
            <button class="btn btn-link" *ngIf="(readOnly$ | async) === false" (click)="reset()">Reset</button>
        </div>
    </div>
    <div class="row mt-3">
        <div class="col-sm-auto col-9">
            <div class="input-group">
                <input
                    type="date"
                    class="form-control input-group-sm date-input"
                    id="{{ (replacementDate$ | async).id }}"
                    #dateInput
                    [formControl]="dateInputControl"
                    [attr.aria-label]="'REPLACEMENT_OR_LAST_PROCEDURE_DATE_ARIA_LABEL' | translate"
                />
                <span class="input-group-text" (click)="dateInput.focus()"
                    ><fa-icon [icon]="faCalendar"></fa-icon
                ></span>
            </div>
        </div>
        <div class="col-3 text-sm-start text-end pe-0">
            <button
                class="btn btn-link"
                *ngIf="(readOnly$ | async) === false && !dateInput.disabled"
                (click)="setToday()"
                translate="REPLACEMENT_OR_LAST_PROCEDURE_TODAY_BUTTON_LABEL"
            ></button>
        </div>
    </div>
    <div *ngIf="(replacementDate$ | async)?.controllingCheckpoint.length === 0" class="row mb-3">
        <div class="col not-applicable">
            <div class="checkbox-container">
                <input
                    type="checkbox"
                    class="form-control"
                    id="replacement-date-not-applicable"
                    #checkbox
                    [formControl]="checkboxControl"
                />
                <fa-icon *ngIf="checkbox.checked" [icon]="faCheck" size="2x" (click)="checkbox.click()"></fa-icon>
            </div>
            <label translate="F4M_NOT_APPLICABLE_LABEL" for="replacement-date-not-applicable"></label>
        </div>
    </div>
</fieldset>
